import React from 'react';
import { element, number, string } from 'prop-types';
import { QueryProvider } from '@thd-nucleus/data-sources';
import { Hydrator } from '@thd-olt-component-react/hydrator';
import { ReorderRecommendations } from '@thd-olt-component-react/thd-recs-containers';
import { Card, CardTitle } from '@thd-olt-component-react/core-ui';

import classnames from 'classnames/bind';
import componentStyles from '../components.module.scss';

const styles = classnames.bind(componentStyles);

export function CustomRenderedBuyItAgain({
  SCROLL_BUFFER,
  HOMEPAGE_DELAY_STANDARD,
  PLACEHOLDER,
  REQUEST_KEY,

  id,
  brandTitleMaxLine,
  slidesPer,
}) {
  return (
    <QueryProvider cacheKey="reorder-recognized-homepage">
      <Hydrator
        id="buyItAgain-php-hydrator"
        className={styles('u-height-100')}
        scrollBuffer={SCROLL_BUFFER}
        delay={HOMEPAGE_DELAY_STANDARD}
        placeholder={PLACEHOLDER}
      >
        <Card>
          <CardTitle className="card__title u-width-100" title="Buy It Again" />
          <ReorderRecommendations
            brandTitleMaxLine={brandTitleMaxLine}
            slidesPer={slidesPer}
            hideTitle
            keepAddToCart
            noATCFulfillment
            requestKey={REQUEST_KEY}
            showFallback
            showLoading
            entryId={id}
          />
        </Card>
      </Hydrator>
    </QueryProvider>
  );
}

CustomRenderedBuyItAgain.propTypes = {
  SCROLL_BUFFER: number,
  HOMEPAGE_DELAY_STANDARD: number,
  PLACEHOLDER: element,
  REQUEST_KEY: string,

  id: string,
  brandTitleMaxLine: number,
  slidesPer: number,
};

CustomRenderedBuyItAgain.defaultProps = {
  SCROLL_BUFFER: undefined,
  HOMEPAGE_DELAY_STANDARD: undefined,
  PLACEHOLDER: undefined,
  REQUEST_KEY: undefined,

  id: undefined,
  brandTitleMaxLine: undefined,
  slidesPer: undefined,
};
